module.exports = __webpack_public_path__ + "img/first_zhCn.5104eb83.png";